import React from 'react'
import ShopSubscriptionCheckoutDirect from '../../components/Checkout/ShopSubscriptionCheckoutDirect';
import DashboardHeader from '../../components/Shop/Layout/DashboardHeader';
import DashboardSideBar from '../../components/Shop/Layout/DashboardSideBar';

const ShopSubscriptionCheckoutPage = () => {
  
  return (
    <div className="shop-subscription-checkout-page-container">
        <DashboardHeader />
        <div className="shop-subscription-checkout-page-content">
          <aside className="shop-subscription-checkout-page-sidebar">
            <DashboardSideBar active={3} />
          </aside>
          <main className="shop-subscription-checkout-page-main">
            <ShopSubscriptionCheckoutDirect />
          </main>
        </div>
    </div>
  )
}

export default ShopSubscriptionCheckoutPage ;